import { render, staticRenderFns } from "./LectureProgressRateByUser.vue?vue&type=template&id=412f0dc5&"
import script from "./LectureProgressRateByUser.vue?vue&type=script&lang=ts&"
export * from "./LectureProgressRateByUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports